// extracted by mini-css-extract-plugin
module.exports = {"btn_submit":"CartInformationCompleted_btn_submit__Jyrf4","item":"CartInformationCompleted_item__19kvW"};